import { AxiosMethods } from '../../../../enums';
import { axiosHelper } from '../../../axios-instance';
import { UpdateQuoteRequest, CreateQuoteRequest } from './types';

export * from './types';

export enum QuotesMutationKey {
  UPDATE_QUOTE = 'update_quote',
  CREATE_QUOTE = 'create_quote'
}

/**
 * Update quote (including items)
 * Main endpoint for all quote modifications
 */
export const updateQuoteMutation = () => ({
  mutationKey: [QuotesMutationKey.UPDATE_QUOTE],
  mutationFn: ({ quoteId, body }: UpdateQuoteRequest) =>
    axiosHelper({
      endpoint: `/quote/${quoteId}/edit-quote`,
      method: AxiosMethods.PATCH,
      baseURL: process.env.REVOPS_API,
      body
    })
});

/**
 * Create a new quote
 */
export const createQuoteMutation = () => ({
  mutationKey: [QuotesMutationKey.CREATE_QUOTE],
  mutationFn: (body: CreateQuoteRequest) =>
    axiosHelper({
      endpoint: '/quote/create',
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    }),
  retry: false
});
